export function pick<T extends object, K extends keyof T>(
  obj: T,
  keys: readonly K[]
): Pick<T, K> {
  return Object.fromEntries(keys.map(key => [key, obj[key]])) as Pick<T, K>
}
